import { Container, Grid, makeStyles, Typography } from "@material-ui/core";
import Image from "next/image";
import CustomWidthTooltip from "../../organizationOnePage/components/01/CustomTooltip";

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    backgroundColor: "#fff",
    borderBottomRightRadius: "10px",
    borderBottomLeftRadius: "10px",
    boxShadow: "-1px 2px 5px 0 #0003",
    paddingTop: 70,
    paddingBottom: 10,
  },
  stickyContainer: {
    position: "sticky",
    top: "-210px",
    zIndex: 1000,
  },
  logo: {
    borderRadius: "100%",
  },
  divLogo: {
    position: "absolute",
    backgroundColor: "#fff",
    padding: 2,
    top: "-50px",
    width: 104,
    height: 104,
    borderRadius: "100%",
    boxShadow: "0px 2px 3px 0px rgba(0, 0, 0, 0.10)",
  },
  t1: {
    fontSize: "18px",
    fontWeight: "bold",
    paddingBottom: 10,
    display: "inline-block",
  },
  scoret: {
    fontWeight: "bold",
    fontSize: "18px",
  },
  t2: {
    fontSize: "18px",
    paddingBottom: 10,
    display: "inline-block",
  },
  successCheckBody: {
    position: "relative !important",
    bottom: "-10px",
    padding: "0 10px",
  },
  successCheck: {
    display: "block !important",
    position: "absolute !important",
    marginBottom: "-10px",
  },
  tooltip: {
    backgroundColor: "#fff !important",
    color: "#000",
    fontSize: "16px",
  },
  grade: {
    width: 40,
    display: "inline-block",
    position: "absolute",
    right: "0px",
    top: "-7px",
  },
  btnGroup: {
    display: "flex",
    cursor: "pointer",
    flexBasis: "auto",
    position: "relative",
  },
  btnPar: {
    width: 50,
    backgroundColor: "#009693",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottomRightRadius: "5px",
    borderTopRightRadius: "5px",
    borderLeft: "solid 1px #fff",
  },
  btn: {
    borderRadius: "0px",
    borderBottomLeftRadius: "5px",
    borderTopLeftRadius: "5px",
  },
  fg: {
    flexGrow: "1",
  },
  tr: {
    transform: "rotate(90deg)",
  },
  dotsPar: {
    display: "flex",

    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5px",
    boxShadow: "0 2px 10px 0 #0002",
    width: 40,
    height: 40,
    cursor: "pointer",
    position: "relative",
  },
  dots: {
    fontSize: 25,
    paddingTop: 0,
    fontWeight: "bold",
    color: "#009693",
    marginTop: "-10px",
  },
  btnMember: {
    boxShadow: "1px 2px 10px #29292944",
  },
}));
const NewInfoPart = ({ orgDat, data, globalProps2 }) => {
  const classes = useStyles();
  return (
    <>
      <Grid item md={12}>
        <div>
          {globalProps2?.banner && (
            <Image
              title={globalProps2.brand_name || globalProps2.name}
              alt={globalProps2.brand_name || globalProps2.name}
              src={globalProps2.banner}
              //   placeholder="blur"
              blurglobalProps2URL={globalProps2.banner}
              layout="responsive"
              width={1280}
              height={300}
            />
          )}
          <Container className={classes.container}>
            {globalProps2?.logo && (
              <div className={classes.divLogo}>
                <Image
                  title={globalProps2.brand_name || globalProps2.name}
                  alt={globalProps2.brand_name || globalProps2.name}
                  src={globalProps2.logo}
                  //   placeholder="blur"
                  blurglobalProps2URL={globalProps2.logo}
                  width={100}
                  height={100}
                  className={classes.logo}
                />
              </div>
            )}
            <Grid container>
              <Grid item md={6} container>
                <Grid item xs={12}>
                  <Typography variant="h1" className={classes.t1}>
                    {globalProps2?.brand_name || globalProps2?.name}{" "}
                  </Typography>
                  {globalProps2?.grade === "A" ||
                  globalProps2?.grade === "B" ||
                  globalProps2?.grade === "C" ? (
                    <CustomWidthTooltip
                      placement="top-start"
                      arrow
                      leaveDelay={100}
                      followCursor
                      title={
                        <Typography variant="h5" className={classes.tooltip}>
                          تیک آبی نشان دهنده آن است که موسسه مورد نظر اعتبارسنجی
                          و اصالت سنجی شده و امتیاز این سطح را اخذ نموده است.
                        </Typography>
                      }
                    >
                      {/* <span className={classes.successCheckBody}>
                        <Image
                          width={27}
                          height={27}
                          src={successCheck}
                          alt={globalProps2.brand_name || globalProps2.name}
                          // title={globalProps2.brand_name || globalProps2.name}
                          placeholder="blur"
                          className={classes.successCheck}
                        />
                      </span> */}
                    </CustomWidthTooltip>
                  ) : null}
                </Grid>
                {globalProps2?.brand_name ? (
                  <Grid item xs={12}>
                    <Typography variant="h2" className={classes.t2}>
                      {globalProps2.name}
                    </Typography>
                  </Grid>
                ) : (
                  ""
                )}
                {globalProps2?.subject && (
                  <Grid item xs={12}>
                    <Typography variant="h2" className={classes.t2}>
                      {globalProps2.subject}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Container>
        </div>
      </Grid>
    </>
  );
};

export default NewInfoPart;
